import React, { Component } from 'react';
import { MobileNavigation } from 'modules/navbar/containers/MobileNavigation';
import { NavBar } from 'modules/navbar/components/NavBar/NavBar';
import { connect } from 'react-redux';
import { IStore } from 'reducers/index';
import { ROUTES, IRoute, IRouteLink, uploadRoute, downloadRoute } from 'modules/navbar/routes';
import { IRoles } from 'utilities/roles';
import { BUSINNESS_FUNCTIONS } from 'constants/roles';
import { withRouter, RouteComponentProps } from 'react-router';
import { GlobalLoading } from 'components/global-loading';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
import { isFeatureEnabled } from 'utilities/util';
import { uamType } from 'constants/customs';

class _PageWrapper extends Component<IMapStateToProps & RouteComponentProps<{}>> {
    public render() {
        const routes = this.filterRoutes();
        const isUploadFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_BULK_UPLOAD_CHARGES_IMPORT, this.props.featureToggles) || isFeatureEnabled(FEATURE_TOGGLES.FINOPS_BULK_UPLOAD_CHARGES_EXPORT, this.props.featureToggles);
        const isDownloadFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_BULK_DOWNLOAD_CHARGES, this.props.featureToggles) || isFeatureEnabled(FEATURE_TOGGLES.FINOPS_BULK_DOWNLOAD_CHARGES_EXPORTJOB, this.props.featureToggles);
        const permissions = this.props.userPermissions?.permissions?.find((permission:any) => permission.businessCapabilityName === uamType.JOBCOSTING || permission.businessCapabilityName === uamType.ADMIN);
        if(isUploadFeatureEnabled) {
            const links = routes.find(item => item.name === 'Exception management')?.links
            if (links?.indexOf(uploadRoute) === -1) {
                links?.push(uploadRoute)
            }
        }
        if(isDownloadFeatureEnabled && permissions?.permission !== '') {
            const links = routes.find(item => item.name === 'Exception management')?.links
            if (links?.indexOf(downloadRoute) === -1) {
                links?.push(downloadRoute)
            } 
        }

        return (
            <div className="lsg-content">
                <header className="ds-header app-logged-in">
                    <NavBar routes={routes} />
                </header>
                <GlobalLoading />
                {this.props.featureDataLoaded && this.props.children}
                <MobileNavigation routes={routes} />
            </div>
        )
    }

    private filterRoutes = (): IRoute[] => {
        const targetRoute = ROUTES;
        return targetRoute.reduce((routes: IRoute[], route: IRoute) => {
            if (route.links) {
                const links = route.links.filter((link: IRouteLink) => (this.filterRouteForRole(link) && this.filterRouteForFeatureToggle(link)));
                if (links.length) {
                    route.links = links;
                    routes.push(route);
                }
                return routes;
            }
            if (this.filterRouteForRole(route) && this.filterRouteForFeatureToggle(route)) {
                routes.push(route);
            }
            return routes;
        }, []);
    };

    private filterRouteForRole = (route: IRoute | IRouteLink) => {
        const returnVal = this.props.userRoles.find((role: IRoles) =>
            route.businessFunctions !== undefined && route.businessFunctions.includes(role.name as BUSINNESS_FUNCTIONS)
        )
        return returnVal !== undefined;
    }

    private filterRouteForFeatureToggle = (route: IRoute | IRouteLink) => {
        if (route.featureToggles === undefined) {
            return true;
        }
        const returnVal = this.props.featureToggles.find((feature: IFeatureToggleModel) =>
            route.featureToggles !== undefined && feature.state && route.featureToggles.includes(feature.featureName as FEATURE_TOGGLES)
        )
        return returnVal !== undefined;
    }
}

interface IMapStateToProps {
    userRoles: IRoles[];
    featureToggles: IFeatureToggleModel[];
    featureDataLoaded: boolean;
    userPermissions: any;
}

const mapStateToProps = (state: IStore): IMapStateToProps => ({
    userRoles: state.user.roles,
    featureToggles: state.featureToggle.featureToggles,
    featureDataLoaded: state.featureToggle.isFeatureDataReady,
    userPermissions: state.user.userPermissions,
});

export default withRouter(connect<IMapStateToProps, {}, {}, IStore>(mapStateToProps)(_PageWrapper));
